<template>
  <!-- 配货拆分-检品不良唛头打印 -->
  <div class="defective-inspection-label">
    <div class="date">打印日期：{{ viewData.print_date }}</div>
    <div class="customer">
      <span>客户名：</span>
      <span>{{ viewData.user_name }}</span>
    </div>
    <div class="badge">{{ viewData.level }}</div>

    <div class="defective-panel">
      <div class="defective-code">
        <span class="code-label">不良品编码：</span>
        <span class="code-value">{{ viewData.defective_code }}</span>
      </div>
      <div class="defective-barcode">
        <canvas ref="defectiveBarcode" width="1000" height="174"></canvas>
      </div>
      <div class="defective-count-row">
        <div class="count-label">不良数</div>
        <div class="count-value">{{ viewData.defective_count }}</div>
      </div>
    </div>

    <div class="detail">
      <div class="detail-row order-row">
        <div class="detail-label">订单编号：</div>
        <div class="order-value">{{ viewData.order_sn }}</div>
        <div class="sorting-value">{{ viewData.sorting }}番</div>
      </div>
      <div class="detail-row attr-row">
        <div class="detail-label">商品属性：</div>
        <div class="detail-value">{{ viewData.attribute_cn }}</div>
      </div>
      <div class="detail-row color-row">
        <div class="detail-label">颜色：</div>
        <div class="detail-value">{{ viewData.color }}</div>
      </div>
      <div class="detail-row size-row">
        <div class="detail-label">尺寸：</div>
        <div class="detail-value">{{ viewData.size }}</div>
      </div>
      <div class="detail-row express-row">
        <div class="detail-label">物流单号：</div>
        <div class="detail-value">{{ viewData.express_no }}</div>
      </div>
    </div>

    <div class="sign-grid">
      <div class="sign-cell">核查员：</div>
      <div class="sign-cell">{{ viewData.checker_name }}</div>
      <div class="sign-cell">采购员：</div>
      <div class="sign-cell">{{ viewData.purchaser_name }}</div>
      <div class="sign-cell">业务员：</div>
      <div class="sign-cell">{{ viewData.salesman_name }}</div>
      <div class="sign-cell">检品员：</div>
      <div class="sign-cell">{{ viewData.inspector_name }}</div>
    </div>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode'

export default {
  name: 'DefectiveInspectionLabel',
  props: {
    labelData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    viewData() {
      const data = this.labelData || {}
      return {
        print_date: data.print_date || '2025-01-01',
        level: data.level || 'SVIP',
        user_name: data.user_name || '株式会社XXXXX-0056',
        defective_code: data.defective_code || 'BL-295059-01-0043',
        defective_count: data.defective_count || '100',
        order_sn: data.order_sn || 'E2025102414561395-10595',
        sorting: data.sorting || '3',
        attribute_cn: data.attribute_cn || '（中文）',
        color: data.color || '蓝色',
        size: data.size || '19寸',
        express_no: data.express_no || '84901294411',
        checker_name: data.checker_name || '名字名字',
        purchaser_name: data.purchaser_name || '名字名字',
        salesman_name: data.salesman_name || '名字名字',
        inspector_name: data.inspector_name || '名字名字'
      }
    }
  },
  mounted() {
    this.createBarcode()
  },
  watch: {
    labelData: {
      deep: true,
      handler() {
        this.$nextTick(this.createBarcode)
      }
    }
  },
  methods: {
    createBarcode() {
      if (!this.$refs.defectiveBarcode || !this.viewData.defective_code) return
      JsBarcode(this.$refs.defectiveBarcode, this.viewData.defective_code, {
        format: 'CODE128',
        displayValue: false,
        height: 174,
        width: 3,
        margin: 0,
        lineColor: '#000000'
      })
    }
  }
}
</script>

<style scoped>
.defective-inspection-label {
  /* token paint_5:03 #FFFFFF */
  /* token paint_22:056 #000000 */
  /* token font_252:88141 Microsoft YaHei 32/32 400 */
  /* token font_252:88184 Microsoft YaHei 48/48 400 */
  /* token font_252:88212 Microsoft YaHei 60/60 700 */
  /* token font_252:88465 Microsoft YaHei 40/54 700 */
  /* token font_252:88471 Microsoft YaHei 40/54 400 */
  /* token font_313:98308 Microsoft YaHei 48/48 700 */
  /* token font_313:98412 Microsoft YaHei 64/64 700 */
  position: relative;
  box-sizing: border-box;
  width: 1080px;
  height: 1600px;
  border: 5px solid #000;
  overflow: hidden;
  color: #000;
  background: #fff;
  font-family: "Microsoft YaHei", SimHei, Arial, sans-serif;
}

.date {
  position: absolute;
  left: 40px;
  top: 40px;
  width: 338px;
  height: 32px;
  font-size: 32px;
  font-weight: 400;
  line-height: 32px;
}

.customer {
  position: absolute;
  left: 40px;
  top: 152px;
  display: flex;
  gap: 20px;
  align-items: center;
  width: 693px;
  height: 48px;
  font-size: 48px;
  font-weight: 400;
  line-height: 48px;
  white-space: nowrap;
}

.badge {
  position: absolute;
  right: 0;
  top: 0;
  box-sizing: border-box;
  width: 248px;
  height: 124px;
  padding: 30px 50px;
  color: #fff;
  background: #000;
  font-size: 64px;
  font-weight: 700;
  line-height: 64px;
  text-align: center;
}

.defective-panel {
  position: absolute;
  left: 0;
  top: 280px;
  box-sizing: border-box;
  width: 1080px;
  height: 472px;
  border-top: 5px solid #000;
}

.defective-code {
  position: absolute;
  left: 147px;
  top: 35px;
  display: flex;
  gap: 20px;
  align-items: center;
  width: 786px;
  height: 48px;
  font-size: 48px;
  line-height: 48px;
  white-space: nowrap;
}

.code-label {
  width: 288px;
  font-weight: 400;
}

.code-value {
  width: 478px;
  font-weight: 700;
}

.defective-barcode {
  position: absolute;
  left: 40px;
  top: 113px;
  width: 1000px;
  height: 174px;
}

.defective-barcode canvas {
  display: block;
  width: 1000px !important;
  height: 174px !important;
}

.defective-count-row {
  position: absolute;
  left: 0;
  top: 317px;
  display: flex;
  width: 1080px;
  height: 150px;
}

.count-label,
.count-value {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 150px;
  border-top: 5px solid #000;
  border-bottom: 5px solid #000;
  font-size: 60px;
  font-weight: 700;
  line-height: 60px;
}

.count-label {
  width: 500px;
  border-left: 5px solid #000;
  border-right: 5px solid #000;
  color: #fff;
  background: #000;
}

.count-value {
  width: 580px;
  border-right: 5px solid #000;
  background: #fff;
}

.detail {
  position: absolute;
  left: 40px;
  top: 832px;
  width: 1000px;
  height: 470px;
}

.detail-row {
  position: absolute;
  left: 0;
  display: flex;
  width: 1000px;
  min-height: 54px;
  font-size: 40px;
  line-height: 54px;
}

.detail-label {
  flex: 0 0 240px;
  font-weight: 400;
}

.detail-value,
.order-value,
.sorting-value {
  font-weight: 700;
}

.order-value {
  width: 559px;
}

.sorting-value {
  flex: 1;
  text-align: right;
}

.order-row {
  top: 0;
}

.attr-row {
  top: 134px;
}

.color-row {
  top: 208px;
}

.size-row {
  top: 282px;
}

.express-row {
  top: 416px;
}

.sign-grid {
  position: absolute;
  left: 0;
  bottom: 0;
  display: grid;
  grid-template-columns: 240px 300px 240px 300px;
  width: 1080px;
  height: 228px;
}

.sign-cell {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 114px;
  padding: 30px 40px;
  border-top: 5px solid #000;
  font-size: 40px;
  font-weight: 400;
  line-height: 54px;
  white-space: nowrap;
}

.sign-cell:not(:nth-child(4n + 1)) {
  border-left: 5px solid #000;
}

@media print {

  .defective-inspection-label {
    width: 1080px;
    height: 1600px;
    page-break-after: always;
  }
}
</style>
